import React from "react";
import { Spinner } from "react-bootstrap";

interface IProps {
  message?: string;
}

export const ZeosSpinner = (props: IProps) => (
  <div className="flex justify-center items-center h-52 w-full">
    <div className="relative inline-flex">
      <Spinner
        animation="border"
        role="status"
        className="text-zeos-orange-dk"
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>

      {props.message && (
        <p className="ml-4 mt-1 text-md text-zeos-black">
        {props.message}
      </p>
      )}
    </div>
  </div>
);
